// production
const backendUrl = 'https://ads-platform.herokuapp.com';

//dev
// const backendUrl = 'http://localhost:3005';
export default backendUrl;
